import Loading from 'element-ui/lib/loading';
export default {
	install(Vue) {
		// 定义一个全局属性来控制loading状态
		Vue.prototype.$loading = false;
		Vue.prototype.$startLoading = function() {
			this.$loading = true;
			this.loadingInstance = Loading.service({
				fullscreen: true,
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		};
		Vue.prototype.$endLoading = function() {
			this.$loading = false;
			this.loadingInstance.close();
		};
	}
};